import {ModelContext} from '../../../types/app.types';
import {PriceModel} from '../Price.model';
import {Tax} from '@wix/auto_sdk_ecom_cart-v-2';
import {MultiCurrencyPrice} from '@wix/auto_sdk_ecom_current-cart';

export class TaxModel {
  public name?: string;
  public amount: PriceModel;

  constructor(params: TaxModel) {
    this.name = params.name;
    this.amount = params.amount;
  }

  public static fromCartV1(
    {taxName, amount}: {taxName: string; amount: MultiCurrencyPrice},
    modelContext: ModelContext
  ): TaxModel {
    return new TaxModel({
      name: taxName,
      amount: PriceModel.fromCartV1(amount, modelContext),
    });
  }

  public static fromCartV2(tax: Tax, modelContext: ModelContext): TaxModel {
    return new TaxModel({
      name: tax.name?.translated ?? /* istanbul ignore next */ tax.name?.original,
      amount: PriceModel.fromCartV2(tax.amount, modelContext),
    });
  }
}
